import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api, ApiRequestError } from '@/lib/api.js';
import { useParamsStore } from '@/stores/paramsStore.js';
import { useViewStore } from '@/stores/viewStore.js';
import type { NoiseParams } from '@wg/shared';

export function useHydrateFromSlug() {
  const { slug } = useParams<{ slug?: string }>();
  const applyParams = useParamsStore((s) => s.setAll);
  const setPalette = useViewStore((s) => s.setPalette);
  const setRenderMode = useViewStore((s) => s.setRenderMode);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    (async () => {
      try {
        const w = await api.worlds.get(slug);
        if (cancelled) return;
        applyParams(JSON.parse(w.paramsJson) as NoiseParams);
        setPalette(w.paletteId);
        setRenderMode(w.renderMode);
      } catch (e) {
        if (e instanceof ApiRequestError) console.warn('world not found:', slug);
        else console.error('[hydrate] unexpected error for slug:', slug, e);
      }
    })();
    return () => { cancelled = true; };
  }, [slug, applyParams, setPalette, setRenderMode]);
}
